<template>
    <div class="travellingDiary__emailShare">
        <div class="container">
            <div class="emailShare__content">
                <div class="emailShare__container">
                    <div class="emailShare__leftCon">
                        <img src="../../assets/lettersLogo.png">
                        <p>欢迎来稿分享</p>
                    </div>
                    <div class="emailShare__rightCon">
                        <p>皇家加勒比非常欢迎老顾客向我们和更多新朋友分享过往的精彩旅程</p>
                        <p style="margin-bottom: 0">请以图文的形式发送到以下邮箱：</p>
                        <div class="emailShare__emailTxt">
                            <a href="mailto:review@rcclapac.com">review@rcclapac.com</a>
                        </div>
                        <p>我们每月都会挑选优秀的作品展现在这个版块，并赠予带有皇家加勒比标志的纪念品。</p>
                        <a class="downloadTemplet" href="https://resource.rcclchina.com.cn/Review/Review%20Template-new1.docx">游记规范及模板下载请点击此处</a>
                        <img onclick="window.location.href = 'https://resource.rcclchina.com.cn/Review/Review%20Template-new1.docx'" style="width:50px;cursor:pointer;" src="https://resource.rcclchina.com.cn/Review/page/%E6%B8%B8%E8%AE%B0%E6%A8%A1%E6%9D%BF%E4%B8%8B%E8%BD%BD%E5%9B%BE%E6%A0%87.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'EmailShareInDetail',
        props: {},
    }
</script>

<style lang="less" scoped>
    /*邮箱分享*/
    .travellingDiary__emailShare{
        width: 100%;
    }
    .emailShare__content{
        background: #1b7492;
        padding:44px 124px 20px 124px;
    }
    .emailShare__container{
        min-width: 850px;
    }
    .emailShare__content p{
        color: #fff;
        margin-bottom: 20px;
    }
    .emailShare__leftCon{
        display: inline-block;
        text-align: center;
    }
    .emailShare__leftCon p{
        font-size: 24px;
        margin-top: 30px;
    }
    .emailShare__leftCon img{
        width:112px;
        height:120px;
    }
    .emailShare__rightCon{
        display: inline-block;
        margin-left: 10%;
    }
    .emailShare__emailTxt {
        margin-bottom:20px;
    }
    .emailShare__emailTxt a{
        font-size: 36px;
        color:#fff;
        text-decoration:underline;
    }
    .emailShare__emailTxt a:hover{
        color:#fff;
    }
    /* 下载模板 */
    .downloadTemplet {
        display: inline-block;
        vertical-align: middle;
        margin-right: 3px;
        color:#FFF !important;
        font-size:19px;
    }
</style>
